import { render, staticRenderFns } from "./CustomCollapse.vue?vue&type=template&id=0a284ecc&scoped=true&"
import script from "./CustomCollapse.vue?vue&type=script&lang=js&"
export * from "./CustomCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a284ecc",
  null
  
)

export default component.exports